export const linkedInIndustries = [
  {
    code: 1,
    category: 'Defense and Space Manufacturing',
  },
  {
    code: 3,
    category: 'Computer Hardware Manufacturing',
  },
  {
    code: 4,
    category: 'Software Development',
  },
  {
    code: 5,
    category: 'Computer Networking Products',
  },
  {
    code: 6,
    category: 'Technology, Information and Internet',
  },
  {
    code: 7,
    category: 'Semiconductor Manufacturing',
  },
  {
    code: 8,
    category: 'Telecommunications',
  },
  {
    code: 9,
    category: 'Law Practice',
  },
  {
    code: 10,
    category: 'Legal Services',
  },
  {
    code: 11,
    category: 'Business Consulting and Services',
  },
  {
    code: 12,
    category: 'Biotechnology',
  },
  {
    code: 13,
    category: 'Medical Practices',
  },
  {
    code: 14,
    category: 'Hospitals and Health Care',
  },
  {
    code: 15,
    category: 'Pharmaceutical Manufacturing',
  },
  {
    code: 16,
    category: 'Veterinary Services',
  },
  {
    code: 17,
    category: 'Medical Equipment Manufacturing',
  },
  {
    code: 18,
    category: 'Personal Care Product Manufacturing',
  },
  {
    code: 19,
    category: 'Retail Apparel and Fashion',
  },
  {
    code: 20,
    category: 'Sporting Goods Manufacturing',
  },
  {
    code: 21,
    category: 'Tobacco Manufacturing',
  },
  {
    code: 22,
    category: 'Retail Groceries',
  },
  {
    code: 23,
    category: 'Food and Beverage Manufacturing',
  },
  {
    code: 24,
    category: 'Computers and Electronics Manufacturing',
  },
  {
    code: 25,
    category: 'Manufacturing',
  },
  {
    code: 26,
    category: 'Furniture and Home Furnishings Manufacturing',
  },
  {
    code: 27,
    category: 'Retail',
  },
  {
    code: 28,
    category: 'Entertainment Providers',
  },
  {
    code: 29,
    category: 'Gambling Facilities and Casinos',
  },
  {
    code: 30,
    category: 'Travel Arrangements',
  },
  {
    code: 31,
    category: 'Hospitality',
  },
  {
    code: 32,
    category: 'Restaurants',
  },
  {
    code: 33,
    category: 'Spectator Sports',
  },
  {
    code: 34,
    category: 'Food and Beverage Services',
  },
  {
    code: 35,
    category: 'Movies, Videos and Sound',
  },
  {
    code: 36,
    category: 'Broadcast Media Production and Distribution',
  },
  {
    code: 37,
    category: 'Museums, Historical Sites, and Zoos',
  },
  {
    code: 38,
    category: 'Artists and Writers',
  },
  {
    code: 39,
    category: 'Performing Arts',
  },
  {
    code: 40,
    category: 'Recreational Facilities',
  },
  {
    code: 41,
    category: 'Banking',
  },
  {
    code: 42,
    category: 'Insurance',
  },
  {
    code: 43,
    category: 'Financial Services',
  },
  {
    code: 44,
    category: 'Real Estate',
  },
  {
    code: 45,
    category: 'Investment Banking',
  },
  {
    code: 46,
    category: 'Investment Management',
  },
  {
    code: 47,
    category: 'Accounting',
  },
  {
    code: 48,
    category: 'Construction',
  },
  {
    code: 49,
    category: 'Wholesale Building Materials',
  },
  {
    code: 50,
    category: 'Architecture and Planning',
  },
  {
    code: 51,
    category: 'Civil Engineering',
  },
  {
    code: 52,
    category: 'Aviation and Aerospace Component Manufacturing',
  },
  {
    code: 53,
    category: 'Motor Vehicle Manufacturing',
  },
  {
    code: 54,
    category: 'Chemical Manufacturing',
  },
  {
    code: 55,
    category: 'Machinery Manufacturing',
  },
  {
    code: 56,
    category: 'Mining',
  },
  {
    code: 57,
    category: 'Oil and Gas',
  },
  {
    code: 58,
    category: 'Shipbuilding',
  },
  {
    code: 59,
    category: 'Utilities',
  },
  {
    code: 60,
    category: 'Textile Manufacturing',
  },
  {
    code: 61,
    category: 'Paper and Forest Product Manufacturing',
  },
  {
    code: 62,
    category: 'Railroad Equipment Manufacturing',
  },
  {
    code: 63,
    category: 'Farming',
  },
  {
    code: 64,
    category: 'Ranching',
  },
  {
    code: 65,
    category: 'Dairy Product Manufacturing',
  },
  {
    code: 66,
    category: 'Fisheries',
  },
  {
    code: 67,
    category: 'Primary and Secondary Education',
  },
  {
    code: 68,
    category: 'Higher Education',
  },
  {
    code: 69,
    category: 'Education Administration Programs',
  },
  {
    code: 70,
    category: 'Research Services',
  },
  {
    code: 71,
    category: 'Armed Forces',
  },
  {
    code: 72,
    category: 'Legislative Offices',
  },
  {
    code: 73,
    category: 'Administration of Justice',
  },
  {
    code: 74,
    category: 'International Affairs',
  },
  {
    code: 75,
    category: 'Government Administration',
  },
  {
    code: 76,
    category: 'Executive Offices',
  },
  {
    code: 77,
    category: 'Law Enforcement',
  },
  {
    code: 78,
    category: 'Public Safety',
  },
  {
    code: 79,
    category: 'Public Policy Offices',
  },
  {
    code: 80,
    category: 'Advertising Services',
  },
  {
    code: 81,
    category: 'Newspaper Publishing',
  },
  {
    code: 82,
    category: 'Book and Periodical Publishing',
  },
  {
    code: 83,
    category: 'Printing Services',
  },
  {
    code: 84,
    category: 'Information Services',
  },
  {
    code: 85,
    category: 'Libraries',
  },
  {
    code: 86,
    category: 'Environmental Services',
  },
  {
    code: 87,
    category: 'Freight and Package Transportation',
  },
  {
    code: 88,
    category: 'Individual and Family Services',
  },
  {
    code: 89,
    category: 'Religious Institutions',
  },
  {
    code: 90,
    category: 'Civic and Social Organizations',
  },
  {
    code: 91,
    category: 'Consumer Services',
  },
  {
    code: 92,
    category: 'Truck Transportation',
  },
  {
    code: 93,
    category: 'Warehousing and Storage',
  },
  {
    code: 94,
    category: 'Airlines and Aviation',
  },
  {
    code: 95,
    category: 'Maritime Transportation',
  },
  {
    code: 96,
    category: 'IT Services and IT Consulting',
  },
  {
    code: 97,
    category: 'Market Research',
  },
  {
    code: 98,
    category: 'Public Relations and Communications Services',
  },
  {
    code: 99,
    category: 'Design Services',
  },
  {
    code: 100,
    category: 'Non-profit Organizations',
  },
  {
    code: 101,
    category: 'Fundraising',
  },
  {
    code: 102,
    category: 'Strategic Management Services',
  },
  {
    code: 103,
    category: 'Writing and Editing',
  },
  {
    code: 104,
    category: 'Staffing and Recruiting',
  },
  {
    code: 105,
    category: 'Professional Training and Coaching',
  },
  {
    code: 106,
    category: 'Venture Capital and Private Equity Principals',
  },
  {
    code: 107,
    category: 'Political Organizations',
  },
  {
    code: 108,
    category: 'Translation and Localization',
  },
  {
    code: 109,
    category: 'Computer Games',
  },
  {
    code: 110,
    category: 'Events Services',
  },
  {
    code: 111,
    category: 'Retail Art Supplies',
  },
  {
    code: 112,
    category: 'Appliances, Electrical, and Electronics Manufacturing',
  },
  {
    code: 113,
    category: 'Online Audio and Video Media',
  },
  {
    code: 114,
    category: 'Nanotechnology Research',
  },
  {
    code: 115,
    category: 'Musicians',
  },
  {
    code: 116,
    category: 'Transportation, Logistics, Supply Chain and Storage',
  },
  {
    code: 117,
    category: 'Plastics Manufacturing',
  },
  {
    code: 118,
    category: 'Computer and Network Security',
  },
  {
    code: 119,
    category: 'Wireless Services',
  },
  {
    code: 120,
    category: 'Alternative Dispute Resolution',
  },
  {
    code: 121,
    category: 'Security and Investigations',
  },
  {
    code: 122,
    category: 'Facilities Services',
  },
  {
    code: 123,
    category: 'Outsourcing and Offshoring Consulting',
  },
  {
    code: 124,
    category: 'Wellness and Fitness Services',
  },
  {
    code: 125,
    category: 'Alternative Medicine',
  },
  {
    code: 126,
    category: 'Media Production',
  },
  {
    code: 127,
    category: 'Animation and Post-production',
  },
  {
    code: 128,
    category: 'Leasing Non-residential Real Estate',
  },
  {
    code: 129,
    category: 'Capital Markets',
  },
  {
    code: 130,
    category: 'Think Tanks',
  },
  {
    code: 131,
    category: 'Philanthropic Fundraising Services',
  },
  {
    code: 132,
    category: 'E-Learning Providers',
  },
  {
    code: 133,
    category: 'Wholesale',
  },
  {
    code: 134,
    category: 'Wholesale Import and Export',
  },
  {
    code: 135,
    category: 'Industrial Machinery Manufacturing',
  },
  {
    code: 136,
    category: 'Photography',
  },
  {
    code: 137,
    category: 'Human Resources Services',
  },
  {
    code: 138,
    category: 'Retail Office Equipment',
  },
  {
    code: 139,
    category: 'Mental Health Care',
  },
  {
    code: 140,
    category: 'Graphic Design',
  },
  {
    code: 141,
    category: 'International Trade and Development',
  },
  {
    code: 142,
    category: 'Beverage Manufacturing',
  },
  {
    code: 143,
    category: 'Retail Luxury Goods and Jewelry',
  },
  {
    code: 144,
    category: 'Renewable Energy Semiconductor Manufacturing',
  },
  {
    code: 145,
    category: 'Glass, Ceramics and Concrete Manufacturing',
  },
  {
    code: 146,
    category: 'Packaging and Containers Manufacturing',
  },
  {
    code: 147,
    category: 'Automation Machinery Manufacturing',
  },
  {
    code: 148,
    category: 'Government Relations Services',
  },
  {
    code: 150,
    category: 'Horticulture',
  },
  {
    code: 201,
    category: 'Farming, Ranching, Forestry',
  },
  {
    code: 256,
    category: 'Ranching and Fisheries',
  },
  {
    code: 298,
    category: 'Forestry and Logging',
  },
  {
    code: 332,
    category: 'Oil, Gas, and Mining',
  },
  {
    code: 341,
    category: 'Coal Mining',
  },
  {
    code: 345,
    category: 'Metal Ore Mining',
  },
  {
    code: 356,
    category: 'Nonmetallic Mineral Mining',
  },
  {
    code: 382,
    category: 'Electric Power Transmission, Control, and Distribution',
  },
  {
    code: 383,
    category: 'Electric Power Generation',
  },
  {
    code: 384,
    category: 'Hydroelectric Power Generation',
  },
  {
    code: 385,
    category: 'Fossil Fuel Electric Power Generation',
  },
  {
    code: 386,
    category: 'Nuclear Electric Power Generation',
  },
  {
    code: 387,
    category: 'Solar Electric Power Generation',
  },
  {
    code: 388,
    category: 'Environmental Quality Programs',
  },
  {
    code: 389,
    category: 'Geothermal Electric Power Generation',
  },
  {
    code: 390,
    category: 'Biomass Electric Power Generation',
  },
  {
    code: 397,
    category: 'Natural Gas Distribution',
  },
  {
    code: 398,
    category: 'Water, Waste, Steam, and Air Conditioning Services',
  },
  {
    code: 400,
    category: 'Water Supply and Irrigation Systems',
  },
  {
    code: 404,
    category: 'Steam and Air-Conditioning Supply',
  },
  {
    code: 406,
    category: 'Building Construction',
  },
  {
    code: 408,
    category: 'Residential Building Construction',
  },
  {
    code: 413,
    category: 'Nonresidential Building Construction',
  },
  {
    code: 419,
    category: 'Utility System Construction',
  },
  {
    code: 428,
    category: 'Subdivision of Land',
  },
  {
    code: 431,
    category: 'Highway, Street, and Bridge Construction',
  },
  {
    code: 435,
    category: 'Specialty Trade Contractors',
  },
  {
    code: 436,
    category: 'Building Structure and Exterior Contractors',
  },
  {
    code: 453,
    category: 'Building Equipment Contractors',
  },
  {
    code: 460,
    category: 'Building Finishing Contractors',
  },
  {
    code: 481,
    category: 'Animal Feed Manufacturing',
  },
  {
    code: 495,
    category: 'Sugar and Confectionery Product Manufacturing',
  },
  {
    code: 504,
    category: 'Fruit and Vegetable Preserves Manufacturing',
  },
  {
    code: 521,
    category: 'Meat Products Manufacturing',
  },
  {
    code: 528,
    category: 'Seafood Product Manufacturing',
  },
  {
    code: 529,
    category: 'Baked Goods Manufacturing',
  },
  {
    code: 562,
    category: 'Breweries',
  },
  {
    code: 564,
    category: 'Distilleries',
  },
  {
    code: 598,
    category: 'Apparel Manufacturing',
  },
  {
    code: 615,
    category: 'Fashion Accessories Manufacturing',
  },
  {
    code: 616,
    category: 'Leather Product Manufacturing',
  },
  {
    code: 622,
    category: 'Footwear Manufacturing',
  },
  {
    code: 625,
    category: "Women's Handbag Manufacturing",
  },
  {
    code: 679,
    category: 'Oil and Coal Product Manufacturing',
  },
  {
    code: 690,
    category: 'Chemical Raw Materials Manufacturing',
  },
  {
    code: 703,
    category: 'Artificial Rubber and Synthetic Fiber Manufacturing',
  },
  {
    code: 709,
    category: 'Agricultural Chemical Manufacturing',
  },
  {
    code: 722,
    category: 'Paint, Coating, and Adhesive Manufacturing',
  },
  {
    code: 727,
    category: 'Soap and Cleaning Product Manufacturing',
  },
  {
    code: 743,
    category: 'Plastics and Rubber Product Manufacturing',
  },
  {
    code: 763,
    category: 'Rubber Products Manufacturing',
  },
  {
    code: 773,
    category: 'Clay and Refractory Products Manufacturing',
  },
  {
    code: 779,
    category: 'Glass Product Manufacturing',
  },
  {
    code: 784,
    category: 'Wood Product Manufacturing',
  },
  {
    code: 794,
    category: 'Lime and Gypsum Products Manufacturing',
  },
  {
    code: 799,
    category: 'Abrasives and Nonmetallic Minerals Manufacturing',
  },
  {
    code: 807,
    category: 'Primary Metal Manufacturing',
  },
  {
    code: 840,
    category: 'Fabricated Metal Products',
  },
  {
    code: 849,
    category: 'Cutlery and Handtool Manufacturing',
  },
  {
    code: 852,
    category: 'Architectural and Structural Metal Manufacturing',
  },
  {
    code: 861,
    category: 'Boilers, Tanks, and Shipping Container Manufacturing',
  },
  {
    code: 871,
    category: 'Construction Hardware Manufacturing',
  },
  {
    code: 873,
    category: 'Spring and Wire Product Manufacturing',
  },
  {
    code: 876,
    category: 'Turned Products and Fastener Manufacturing',
  },
  {
    code: 883,
    category: 'Metal Treatments',
  },
  {
    code: 887,
    category: 'Metal Valve, Ball, and Roller Manufacturing',
  },
  {
    code: 901,
    category: 'Agriculture, Construction, Mining Machinery Manufacturing',
  },
  {
    code: 918,
    category: 'Commercial and Service Industry Machinery Manufacturing',
  },
  {
    code: 923,
    category: 'HVAC and Refrigeration Equipment Manufacturing',
  },
  {
    code: 928,
    category: 'Metalworking Machinery Manufacturing',
  },
  {
    code: 935,
    category: 'Engines and Power Transmission Equipment Manufacturing',
  },
  {
    code: 964,
    category: 'Communications Equipment Manufacturing',
  },
  {
    code: 973,
    category: 'Audio and Video Equipment Manufacturing',
  },
  {
    code: 983,
    category: 'Measuring and Control Instrument Manufacturing',
  },
  {
    code: 994,
    category: 'Magnetic and Optical Media Manufacturing',
  },
  {
    code: 998,
    category: 'Electric Lighting Equipment Manufacturing',
  },
  {
    code: 1005,
    category: 'Household Appliance Manufacturing',
  },
  {
    code: 1029,
    category: 'Transportation Equipment Manufacturing',
  },
  {
    code: 1042,
    category: 'Motor Vehicle Parts Manufacturing',
  },
  {
    code: 1080,
    category: 'Household and Institutional Furniture Manufacturing',
  },
  {
    code: 1090,
    category: 'Office Furniture and Fixtures Manufacturing',
  },
  {
    code: 1095,
    category: 'Mattress and Blinds Manufacturing',
  },
  {
    code: 1128,
    category: 'Wholesale Motor Vehicles and Parts',
  },
  {
    code: 1137,
    category: 'Wholesale Furniture and Home Furnishings',
  },
  {
    code: 1153,
    category: 'Wholesale Photography Equipment and Supplies',
  },
  {
    code: 1157,
    category: 'Wholesale Computer Equipment',
  },
  {
    code: 1166,
    category: 'Wholesale Metals and Minerals',
  },
  {
    code: 1171,
    category: 'Wholesale Appliances, Electrical, and Electronics',
  },
  {
    code: 1178,
    category: 'Wholesale Hardware, Plumbing, Heating Equipment',
  },
  {
    code: 1187,
    category: 'Wholesale Machinery',
  },
  {
    code: 1206,
    category: 'Wholesale Recyclable Materials',
  },
  {
    code: 1208,
    category: 'Wholesale Luxury Goods and Jewelry',
  },
  {
    code: 1212,
    category: 'Wholesale Paper Products',
  },
  {
    code: 1221,
    category: 'Wholesale Drugs and Sundries',
  },
  {
    code: 1222,
    category: 'Wholesale Apparel and Sewing Supplies',
  },
  {
    code: 1230,
    category: 'Wholesale Footwear',
  },
  {
    code: 1231,
    category: 'Wholesale Food and Beverage',
  },
  {
    code: 1250,
    category: 'Wholesale Raw Farm Products',
  },
  {
    code: 1257,
    category: 'Wholesale Chemical and Allied Products',
  },
  {
    code: 1262,
    category: 'Wholesale Petroleum and Petroleum Products',
  },
  {
    code: 1267,
    category: 'Wholesale Alcoholic Beverages',
  },
  {
    code: 1285,
    category: 'Internet Marketplace Platforms',
  },
  {
    code: 1292,
    category: 'Retail Motor Vehicles',
  },
  {
    code: 1309,
    category: 'Retail Furniture and Home Furnishings',
  },
  {
    code: 1319,
    category: 'Retail Appliances, Electrical, and Electronic Equipment',
  },
  {
    code: 1324,
    category: 'Retail Building Materials and Garden Equipment',
  },
  {
    code: 1339,
    category: 'Food and Beverage Retail',
  },
  {
    code: 1359,
    category: 'Retail Health and Personal Care Products',
  },
  {
    code: 1370,
    category: 'Retail Gasoline',
  },
  {
    code: 1407,
    category: 'Retail Musical Instruments',
  },
  {
    code: 1409,
    category: 'Retail Books and Printed News',
  },
  {
    code: 1423,
    category: 'Retail Florists',
  },
  {
    code: 1424,
    category: 'Retail Office Supplies and Gifts',
  },
  {
    code: 1431,
    category: 'Retail Recyclable Materials & Used Merchandise',
  },
  {
    code: 1445,
    category: 'Online and Mail Order Retail',
  },
  {
    code: 1481,
    category: 'Rail Transportation',
  },
  {
    code: 1495,
    category: 'Ground Passenger Transportation',
  },
  {
    code: 1497,
    category: 'Urban Transit Services',
  },
  {
    code: 1504,
    category: 'Interurban and Rural Bus Services',
  },
  {
    code: 1505,
    category: 'Taxi and Limousine Services',
  },
  {
    code: 1512,
    category: 'School and Employee Bus Services',
  },
  {
    code: 1517,
    category: 'Shuttles and Special Needs Transportation Services',
  },
  {
    code: 1520,
    category: 'Pipeline Transportation',
  },
  {
    code: 1532,
    category: 'Sightseeing Transportation',
  },
  {
    code: 1573,
    category: 'Postal Services',
  },
  {
    code: 1594,
    category: 'Technology, Information and Media',
  },
  {
    code: 1600,
    category: 'Periodical Publishing',
  },
  {
    code: 1602,
    category: 'Book Publishing',
  },
  {
    code: 1611,
    category: 'Movies and Sound Recording',
  },
  {
    code: 1623,
    category: 'Sound Recording',
  },
  {
    code: 1625,
    category: 'Sheet Music Publishing',
  },
  {
    code: 1633,
    category: 'Radio and Television Broadcasting',
  },
  {
    code: 1641,
    category: 'Cable and Satellite Programming',
  },
  {
    code: 1644,
    category: 'Telecommunications Carriers',
  },
  {
    code: 1649,
    category: 'Satellite Telecommunications',
  },
  {
    code: 1673,
    category: 'Credit Intermediation',
  },
  {
    code: 1678,
    category: 'Savings Institutions',
  },
  {
    code: 1696,
    category: 'Loan Brokers',
  },
  {
    code: 1713,
    category: 'Securities and Commodity Exchanges',
  },
  {
    code: 1720,
    category: 'Investment Advice',
  },
  {
    code: 1725,
    category: 'Insurance Carriers',
  },
  {
    code: 1737,
    category: 'Insurance Agencies and Brokerages',
  },
  {
    code: 1738,
    category: 'Claims Adjusting, Actuarial Services',
  },
  {
    code: 1742,
    category: 'Funds and Trusts',
  },
  {
    code: 1743,
    category: 'Insurance and Employee Benefit Funds',
  },
  {
    code: 1745,
    category: 'Pension Funds',
  },
  {
    code: 1750,
    category: 'Trusts and Estates',
  },
  {
    code: 1757,
    category: 'Real Estate and Equipment Rental Services',
  },
  {
    code: 1759,
    category: 'Leasing Residential Real Estate',
  },
  {
    code: 1770,
    category: 'Leasing Real Estate Agents and Brokers',
  },
  {
    code: 1779,
    category: 'Equipment Rental Services',
  },
  {
    code: 1786,
    category: 'Consumer Goods Rental',
  },
  {
    code: 1798,
    category: 'Commercial and Industrial Equipment Rental',
  },
  {
    code: 1810,
    category: 'Professional Services',
  },
  {
    code: 1855,
    category: 'IT System Design Services',
  },
  {
    code: 1862,
    category: 'Marketing Services',
  },
  {
    code: 1905,
    category: 'Holding Companies',
  },
  {
    code: 1909,
    category: 'Industry Associations',
  },
  {
    code: 1911,
    category: 'Professional Organizations',
  },
  {
    code: 1912,
    category: 'Administrative and Support Services',
  },
  {
    code: 1916,
    category: 'Office Administration',
  },
  {
    code: 1923,
    category: 'Executive Search Services',
  },
  {
    code: 1925,
    category: 'Temporary Help Services',
  },
  {
    code: 1931,
    category: 'Telephone Call Centers',
  },
  {
    code: 1938,
    category: 'Collection Agencies',
  },
  {
    code: 1956,
    category: 'Security Guards and Patrol Services',
  },
  {
    code: 1958,
    category: 'Security Systems Services',
  },
  {
    code: 1965,
    category: 'Janitorial Services',
  },
  {
    code: 1981,
    category: 'Waste Collection',
  },
  {
    code: 1986,
    category: 'Waste Treatment and Disposal',
  },
  {
    code: 1999,
    category: 'Education',
  },
  {
    code: 2012,
    category: 'Secretarial Schools',
  },
  {
    code: 2018,
    category: 'Technical and Vocational Training',
  },
  {
    code: 2019,
    category: 'Cosmetology and Barber Schools',
  },
  {
    code: 2020,
    category: 'Flight Training',
  },
  {
    code: 2025,
    category: 'Fine Arts Schools',
  },
  {
    code: 2027,
    category: 'Sports and Recreation Instruction',
  },
  {
    code: 2029,
    category: 'Language Schools',
  },
  {
    code: 2040,
    category: 'Physicians',
  },
  {
    code: 2045,
    category: 'Dentists',
  },
  {
    code: 2048,
    category: 'Chiropractors',
  },
  {
    code: 2050,
    category: 'Optometrists',
  },
  {
    code: 2054,
    category: 'Physical, Occupational and Speech Therapists',
  },
  {
    code: 2060,
    category: 'Family Planning Centers',
  },
  {
    code: 2063,
    category: 'Outpatient Care Centers',
  },
  {
    code: 2069,
    category: 'Medical and Diagnostic Laboratories',
  },
  {
    code: 2074,
    category: 'Home Health Care Services',
  },
  {
    code: 2077,
    category: 'Ambulance Services',
  },
  {
    code: 2081,
    category: 'Hospitals',
  },
  {
    code: 2091,
    category: 'Nursing Homes and Residential Care Facilities',
  },
  {
    code: 2112,
    category: 'Services for the Elderly and Disabled',
  },
  {
    code: 2115,
    category: 'Community Services',
  },
  {
    code: 2122,
    category: 'Emergency and Relief Services',
  },
  {
    code: 2125,
    category: 'Vocational Rehabilitation Services',
  },
  {
    code: 2128,
    category: 'Child Day Care Services',
  },
  {
    code: 2130,
    category: 'Performing Arts and Spectator Sports',
  },
  {
    code: 2133,
    category: 'Theater Companies',
  },
  {
    code: 2135,
    category: 'Dance Companies',
  },
  {
    code: 2139,
    category: 'Circuses and Magic Shows',
  },
  {
    code: 2142,
    category: 'Sports Teams and Clubs',
  },
  {
    code: 2143,
    category: 'Racetracks',
  },
  {
    code: 2159,
    category: 'Museums',
  },
  {
    code: 2161,
    category: 'Historical Sites',
  },
  {
    code: 2163,
    category: 'Zoos and Botanical Gardens',
  },
  {
    code: 2167,
    category: 'Amusement Parks and Arcades',
  },
  {
    code: 2179,
    category: 'Golf Courses and Country Clubs',
  },
  {
    code: 2181,
    category: 'Skiing Facilities',
  },
  {
    code: 2190,
    category: 'Accommodation Services',
  },
  {
    code: 2194,
    category: 'Hotels and Motels',
  },
  {
    code: 2197,
    category: 'Bed-and-Breakfasts, Hostels, Homestays',
  },
  {
    code: 2212,
    category: 'Caterers',
  },
  {
    code: 2214,
    category: 'Mobile Food Services',
  },
  {
    code: 2217,
    category: 'Bars, Taverns, and Nightclubs',
  },
  {
    code: 2225,
    category: 'Repair and Maintenance',
  },
  {
    code: 2226,
    category: 'Vehicle Repair and Maintenance',
  },
  {
    code: 2240,
    category: 'Electronic and Precision Equipment Maintenance',
  },
  {
    code: 2247,
    category: 'Commercial and Industrial Machinery Maintenance',
  },
  {
    code: 2253,
    category: 'Reupholstery and Furniture Repair',
  },
  {
    code: 2255,
    category: 'Footwear and Leather Goods Repair',
  },
  {
    code: 2258,
    category: 'Personal and Laundry Services',
  },
  {
    code: 2259,
    category: 'Personal Care Services',
  },
  {
    code: 2272,
    category: 'Laundry and Drycleaning Services',
  },
  {
    code: 2282,
    category: 'Pet Services',
  },
  {
    code: 2318,
    category: 'Household Services',
  },
  {
    code: 2353,
    category: 'Health and Human Services',
  },
  {
    code: 2358,
    category: 'Public Health',
  },
  {
    code: 2360,
    category: 'Public Assistance Programs',
  },
  {
    code: 2366,
    category: 'Air, Water, and Waste Program Management',
  },
  {
    code: 2368,
    category: 'Conservation Programs',
  },
  {
    code: 2369,
    category: 'Housing and Community Development',
  },
  {
    code: 2374,
    category: 'Community Development and Urban Planning',
  },
  {
    code: 2375,
    category: 'Economic Programs',
  },
  {
    code: 2391,
    category: 'Military and International Affairs',
  },
  {
    code: 2401,
    category: 'Operations Consulting',
  },
  {
    code: 2458,
    category: 'Data Infrastructure and Analytics',
  },
  {
    code: 2468,
    category: 'Electrical Equipment Manufacturing',
  },
  {
    code: 2489,
    category: 'Wind Electric Power Generation',
  },
  {
    code: 2500,
    category: 'Wineries',
  },
  {
    code: 2934,
    category: 'Landscaping Services',
  },
  {
    code: 3065,
    category: 'Courts of Law',
  },
  {
    code: 3068,
    category: 'Correctional Institutions',
  },
  {
    code: 3070,
    category: 'Fire Protection',
  },
  {
    code: 3081,
    category: 'Housing Programs',
  },
  {
    code: 3085,
    category: 'Transportation Programs',
  },
  {
    code: 3086,
    category: 'Utilities Administration',
  },
  {
    code: 3089,
    category: 'Space Research and Technology',
  },
  {
    code: 3095,
    category: 'Oil Extraction',
  },
  {
    code: 3096,
    category: 'Natural Gas Extraction',
  },
  {
    code: 3099,
    category: 'Embedded Software Products',
  },
  {
    code: 3100,
    category: 'Mobile Computing Software Products',
  },
  {
    code: 3101,
    category: 'Desktop Computing Software Products',
  },
  {
    code: 3102,
    category: 'IT System Custom Software Development',
  },
  {
    code: 3103,
    category: 'IT System Operations and Maintenance',
  },
  {
    code: 3104,
    category: 'IT System Installation and Disposal',
  },
  {
    code: 3105,
    category: 'IT System Training and Support',
  },
  {
    code: 3106,
    category: 'IT System Data Services',
  },
  {
    code: 3107,
    category: 'IT System Testing and Evaluation',
  },
  {
    code: 3124,
    category: 'Internet News',
  },
  {
    code: 3125,
    category: 'Blogs',
  },
  {
    code: 3126,
    category: 'Interior Design',
  },
  {
    code: 3127,
    category: 'Social Networking Platforms',
  },
  {
    code: 3128,
    category: 'Business Intelligence Platforms',
  },
  {
    code: 3129,
    category: 'Business Content',
  },
  {
    code: 3130,
    category: 'Data Security Software Products',
  },
  {
    code: 3131,
    category: 'Mobile Gaming Apps',
  },
  {
    code: 3132,
    category: 'Internet Publishing',
  },
  {
    code: 3133,
    category: 'Media and Telecommunications',
  },
  {
    code: 3134,
    category: 'Blockchain Services',
  },
  {
    code: 3186,
    category: 'Retail Art Dealers',
  },
  {
    code: 3240,
    category: 'Renewable Energy Power Generation',
  },
  {
    code: 3241,
    category: 'Renewable Energy Equipment Manufacturing',
  },
  {
    code: 3242,
    category: 'Engineering Services',
  },
  {
    code: 3243,
    category: 'Services for Renewable Energy',
  },
] as const

export type LinkedInIndustry = (typeof linkedInIndustries)[number]
export type LinkedInIndustryCode = LinkedInIndustry['code']

type CodeCategoryMap = Map<number, string>

export const codeCategoryMap: CodeCategoryMap = linkedInIndustries.reduce(
  (acc: CodeCategoryMap, industry) => acc.set(industry.code, industry.category),
  new Map(),
)

export const getLinkedInCategory = (code: number | string): string | null => codeCategoryMap.get(Number(code)) || null
